export default __webpack_public_path__ + "locales/lo-LA/Files.json?hash=204d545ac3720011b918bde42c5c35b3";